/**
 * 將日期轉換為本地時間的 YYYY-MM-DD 格式
 * 避免使用 toISOString() 造成的時區問題
 * @param date Date 對象
 * @returns 格式化的日期字符串 (YYYY-MM-DD)
 */
const formatDateForInput = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * 獲取今天的日期字符串，格式為 YYYY-MM-DD
 * @returns 今天的日期字符串
 */
export const getTodayDateString = (): string => {
  return formatDateForInput(new Date());
};
